import type { DataTableColumn, DataTableRenderCellParams } from '@/components/custom/erp/data-table-v2';

export const getDataTableColumns = (): DataTableColumn[] => [
  {
    field: 'checkbox',
    headerName: '',
    width: 50,
    renderCell: (params: DataTableRenderCellParams) => (
      <input type='checkbox' className='cursor-pointer' aria-label={`Select row ${params.id}`} />
    )
  },
  {
    field: 'status',
    headerName: 'Trạng thái',
    width: 120
  },
  {
    field: 'invoiceStatus',
    headerName: 'Trạng thái HĐDT',
    width: 140
  },
  {
    field: 'invoiceNumber',
    headerName: 'Số c/từ',
    width: 120
  },
  {
    field: 'invoiceDate',
    headerName: 'Ngày c/từ',
    width: 120
  },
  {
    field: 'customerCode',
    headerName: 'Mã khách hàng',
    width: 140
  },
  {
    field: 'customerName',
    headerName: 'Tên khách hàng',
    width: 200
  },
  {
    field: 'accountDebit',
    headerName: 'TK nợ',
    width: 100
  },
  {
    field: 'invoiceType',
    headerName: 'Loại hóa đơn',
    width: 130
  },
  {
    field: 'totalAmount',
    headerName: 'Tổng tiền',
    width: 120
  },
  {
    field: 'currency',
    headerName: 'Ngoại tệ',
    width: 100
  },
  {
    field: 'unit',
    headerName: 'Đơn vị',
    width: 100
  },
  {
    field: 'explain',
    headerName: 'Diễn giải',
    width: 200
  }
];
export const getInputTableColumns = (): DataTableColumn[] => [
  {
    field: 'column',
    headerName: 'Cột',
    width: 180
  },
  {
    field: 'columnName',
    headerName: 'Tên cột',
    width: 200
  },
  {
    field: 'columnNameEnglish',
    headerName: 'Tên tiếng anh',
    width: 200
  },
  {
    field: 'width',
    headerName: 'Độ rộng',
    width: 200
  },
  {
    field: 'format',
    headerName: 'Định dạng',
    width: 200
  },
  {
    field: 'align',
    headerName: 'Căn chỉnh',
    width: 200
  },
  {
    field: 'bold',
    headerName: 'In đậm',
    width: 200
  },
  {
    field: 'italic',
    headerName: 'Nghiêng',
    width: 200
  },
  {
    field: 'total',
    headerName: 'Tổng',
    width: 200
  }
];
